export default {
  v3OfficialTopUpCenterTitle: '官网储值中心',
  v3OfficialTopUpCenterKeyword: '官网储值中心',
  v3OfficialTopUpCenterDescription: '官网储值中心',
  v3SafeAndFast: '安全无风险 极速到账',
  v3Shop: '商城',
  v3ShoppingCart: '购物车',
  v3MembershipCenter: '权益中心（大会员中心）',
  v3Login: '登录',
  v3Account: '帐号',
  v3EnterAccountName: '请输入帐号名称',
  v3Password: '密码',
  v3EnterPassword: '请输入密码',
  v3ForgotPassword: '忘记密码',
  v3EnterUID: '请输入UID',
  v3OTP: 'OTP',
  v3EnterOTP: '请输入OTP',
  v3SelectTopUpCharacter: '选择储值角色',
  v3SelectServer: '请选择伺服器',
  v3Confirm: '确认',
  v3CharacterNotFound:
    '若找不到角色，请尝试先在游戏APP中登入角色再来登录储值页面或联系客服',
  v3Logout: '登出',
  v3SwitchAccount: '切换帐号',
  v3MyCoupons: '我的优惠券',
  v3BenefitsCenter: '权益中心',
  v3TopUpBenefits: '储值福利',
  v3MoreSettings: '更多设置',
  v3RememberLoginStatus: '记住我的登录状态',
  v3OrderQuery: '订单查询',
  v3ContactCustomerService: '联系客服',
  v3LoginWithApp: '使用APP登录',
  v3ChooseOtherLoginMethod: '选择其他登录方式',
  v3ConnectingToGameApp: '正在连接游戏APP',
  v3EnsureGameInstalled:
    '请确保该设备已安装游戏。如果游戏为未响应或登录失败，请从应用商店将游戏升级到最新版本或更换其他浏览器。',
  v3OpenGame: '打开游戏',
  v3DownloadGame: '下载游戏',
  v3UpdateGameIfOpenFails: '若打开游戏失败，请从应用商店将游戏升级到最新版本',
  v3ClickToDownloadLatestVersion: '或可点击下载游戏按钮，下载最新版本',
  v3LoggingIntoOfficialTopUpCenter: '您正在登录【官网储值中心】',
  v3CurrentAccount: '当前账号：xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: '欢迎使用官网储值中心',
  v3OfficialAuthorizedLogin: '官方授权登录，安全无风险',
  v3TermsOfService: '服务条款',
  v3PrivacyPolicy: '隐私政策',
  v3ThirdPartySocialAccountDescription: '第三方社交帐号说明',
  v3BindSocialAccountInGameFirst:
    '请先在游戏内用户中心完成社交账号绑定，再使用绑定的社交账号进行登录。',
  v3FirstTopUp15PercentOff: '首次储值最高享15%OFF',
  v3MoreTopUpRebates: '更多储值返利送不停',
  v3LoginToViewOffers: '登录以查看优惠',
  v3TopUpEnvironmentChecking: '储值环境检测中……',
  v3SafeToUse: '安全，可放心使用',
  v3LimitedTimeBenefits: '限时福利',
  v3EventRules: '活动规则',
  v3MoreEvents: '更多活动',
  v3Claim: '领取',
  v3Completed: '已完成',
  v3GoTo: '前往',
  v3ViewDetails: '查看详情',
  v3RecommendedProducts: '推荐商品',
  v3SearchProductName: '搜索商品名称',
  v3AllCategories: '全部分类',
  v3PopularSort: '热门排序',
  v3PriceAscending: '价格升序',
  v3PriceDescending: '价格降序',
  v3DiamondBonus10Percent: '钻石加码10%',
  v3YuanbaoBonus10Percent: '元宝加码10%',
  v3ExtraBonus10Percent: '额外赠送10%',
  v3FirstTopUpDouble: '首充双倍',
  v3FirstExtraBonus: '首次额外赠送',
  v3ProductDetails: '商品详情',
  v3AddToCart: '加入购物车',
  v3AddedToCart: '已添加购物车',
  v3BuyNow: '立即购买',
  v3NoItemsInCart: '您还没选购商品至购物车',
  v3SelectedItemsN: '已选商品（${n}）',
  v3RemoveFromCart: '是否移出购物车',
  v3Yes: '是',
  v3No: '否',
  v3LimitOnePerPurchase: '该商品每次限购一件',
  v3ItemPrice: '商品价格',
  v3Tax: '税',
  v3ExtraGift: '额外赠送',
  v3Total: '合计',
  v3ProceedToPayment: '去支付',
  v3SelectCoupon: '选择优惠券',
  v3UnavailableCoupons: '不可用优惠券',
  v3OneCouponPerOrder: '每笔订单限用一张',
  v3DiscountCoupon: '折扣优惠券',
  v3ThresholdCoupon: '满减优惠券',
  v3MinSpendCoupon: '满xx USD可用',
  v3MaxDiscountCoupon: '最多优惠xxxx USD',
  v3LimitedChannel: '限定渠道可用',
  v3AllChannels: '所有渠道可用',
  v3SpecificProducts: '指定商品可用',
  v3AllProducts: '所有商品可用',
  v3NotYetTimeToUse: '未到使用时间',
  v3Expired: '已过期',
  v3Used: '已使用',
  v3ValidityPeriod: '有效期：',
  v3ConfirmUse: '确认使用',
  v3ChangeProduct: '更换商品',
  v3ConfirmPaymentOrder: '确认支付订单',
  v3StoredValueRole: '储值角色',
  v3TotalNProducts: '共${n}个商品',
  v3SelectPaymentMethod: '选择支付方式',
  v3PayNow: '立即支付',
  v3MorePaymentMethods: '更多支付方式',
  v3NoAvailablePaymentMethodContactSupport: '找不到可用的支付方式？联系客服',
  v3AvailableCoupons: '可用优惠券',
  v3Extra10Percent: '加码10%',
  v3LastSelection: '上次选择',
  v3RecommendedUsage: '推荐使用',
  v3PopularChoice: '热门选择',
  v3PaymentSuccess: '支付成功',
  v3PaymentFailure: '支付失败',
  v3TopUpFailureMessage:
    '非常抱歉储值失败了，请您尝试重新提交订单，或通过下方的客服按钮联系我们',
  v3Game: '游戏',
  v3UID: 'UID',
  v3OrderNumber: '订单编号',
  v3ProductContent: '商品内容',
  v3ViewProductDetails: '查看商品详情',
  v3PaymentMethod: '支付方式',
  v3Complete: '完成',
  v3TopUpAgain: '再储一笔',
  v3FriendlyReminderSaveOrderInfo:
    '温馨提示：截图保存订单信息，方便我们快速处理您的订单',
  v3RechargeAgain: '重新储值',
  v3TransactionInProgress: '交易进行中',
  v3CompletePaymentInChannel: '请前往支付渠道完成订单支付',
  v3RestAssuredFastDeliveryAfterPayment:
    '放心，当我们收到订单支付结果后会最快速度给您发放商品道具',
  v3SaveOrderInfoForProgress: '您可以截图保存订单信息以便确认交易进度',
  v3PaymentCompleted: '我已完成支付',
  v3AddToHomeScreen: '添加到主屏',
  v3AddShortcutForBonus: '添加桌面快捷方式，领取额外奖励',
  v3ShareSuccess: '分享成功',
  v3ShareFailure: '分享失败',
  v3RewardClaimed: '领奖成功',
  v3RewardClaimFailed: '领奖失败',
  v3EventNotStarted: '活动未开始',
  v3EventEnded: '活动已结束',
  v3ClickSelectCoupon: '点击选择优惠券',
  v3CouponsRecommendedUsed: '已使用推荐的优惠券',
  v3CouponsSelected: '已选择优惠券',
  v3NoCouponsAvaliable: '无可用优惠券',
  v3SupplementStatus: '状态',
  v3SupplementNormal: '正常',
  v3SupplementBanned: '已封禁',
  v3SupplementPendingPayment: '待补款',
  v3SupplementSwitchCharacter: '切换角色',
  v3SupplementAccountInfoInvalid: '账号信息失效',
  v3SupplementContactGSForTopUpLink: '请先联系GS获取储值链接',
  v3SupplementTopUpCompleted: '已完成储值：',
  v3SupplementTotalRefundOrders: '共{}笔退款订单',
  v3SupplementPendingSupplementAmount: '待补款金额：',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    '账号/角色正常，不需要补款',
  v3SupplementEnjoyYourGame: '祝您游戏愉快!!',
  v3SupplementOrderInformation: '订单信息',
  v3SupplementPendingPaymentAmount: '待支付金额：',
  v3LookUpCouponRule: '查看优惠券发放规则',
  v3SwitchOldVersion: '切换至旧版本支付平台',
  v3FirstTopUpGiveaway: '首充\n赠送',
  v3SecureConnection: '安全连接中',
  v3RequestTimeOut: '加载超时，请稍后重试',
  v3ConfirmLeave: '确认离开？',
  v3NoSubmitOrder: '您的购物车还未结算，离开后可能错过心仪的商品！',
  v3ContinueSubmit: '继续购买',
  v3LeaveSubmit: '离开',
  v3RecentBug: '最近购买',
  v3ScanCodeLogin: '扫码登录',
  v3BindRole: '绑定角色',
  v3ScanLoading: '加载中...',
  v3ScanExpired: '二维码已过期',
  v3ScanRefreshClick: '请点击刷新重试',
  v3ScanRefreshTip: '请刷新后重新扫码授权',
  v3ScanRefresh: '刷新',
  v3ScanSucc: '扫描成功',
  v3ScanAuth: '请在手机上确认授权',
  v3ScanAuthSuccess: '授权成功',
  v3ScanAuthSuccessTip: '登录中...',
  v3ScanUnauthorized: '未授权',
  v3ScanRefreshTip2: '请打开游戏登录后扫码登录',
  v3ScanGuide: '扫码指引',
  v3ScanLoginError: '登录异常，请刷新后重试',
  v3PwaTapShareOrMenuIcon: '点击浏览器工具栏的 分享 或 菜单 图标',
  v3PwaFindAndTapAddToHomeScreen: '在选项中找到并点击 "添加到主屏幕"',
  v3ThirdPartyLogin: '第三方登录',
  v3NoMyLoginMethod: '没有我的登录方式？',
  v3AccountPasswordLogin: '请输入账号绑定游戏角色',
  v3LaunchFromDesktopAndRewardToMailbox: '请从桌面启动\n选择角色后奖励将发至邮箱',
  v3ClaimSuccessCheckMailbox: '领取成功\n请前往游戏内邮箱查看',
  v3ExclusiveProductTip: '购物车已有此商品，请移除后再加购。',
  v3LifeLimitProductTip: '这个商品无法多次加入购物车\n一次只能加一个',
  v3Notice: '注意',
  v3LifeLimitAddToCartTip: '<span style="font-weight: bold;text-decoration: underline;">【productName】终身限购1次</span>\n仅第一笔成功支付订单可获得【productName】\n若产生额外成功支付，自第二笔订单起\n<span style="font-weight: bold;text-decoration: underline;;">将统一发放【191999星石】</span>',
  v3LifeLimitCancelAddToCart: '取消加入购物车',
  v3LifeLimitConfirmAddToCart: '确认，继续购买',
  v3LifeLimitCancelBuy: '取消购买',
  v3LifeLimitSubmitProductContent: '购物车中包含商品<span style="font-weight: bold;text-decoration: underline;">【productName】</span>\n<span style="font-weight: bold;text-decoration: underline;">此商品终身限购1次</span>\n仅第一笔成功支付订单可获得【productName】\n若产生额外成功支付，<span style="font-weight: bold;text-decoration: underline;">自第二笔订单起将统一发放【191999星石】</span>'
};
